/*
 * Lystia · Cart AJAX сервіс (T-E2-10).
 * Єдине джерело кошика - Shopify cart (cookie), localStorage кошика не використовується.
 * API: window.LystiaCart (singleton). Події на document: cart:loading, cart:change, cart:error.
 * Лише дані й події; розмітка шторки/рядків - окремі секції (E5).
 * Поріг/мінімум приходять з налаштувань теми через необовʼязковий
 * <script type="application/json" id="LystiaCartConfig">{"sections":[],"minOrder":0,"freeShipping":0}</script>
 * (значення в одиницях валюти, A-006/A-009/A-010; ключі налаштувань - T-E2-08).
 */
(function () {
  'use strict';

  var MAX_QTY = 99;

  function readConfig() {
    var el = document.getElementById('LystiaCartConfig');
    if (!el) return {};
    try { return JSON.parse(el.textContent) || {}; } catch (e) { return {}; }
  }

  function route(name, fallback) {
    return (window.routes && window.routes[name]) || fallback;
  }

  class CartError extends Error {
    constructor(message, status, data) {
      super(message);
      this.name = 'CartError';
      this.status = status;
      this.data = data || null;
    }
  }

  class LystiaCartService {
    constructor() {
      this.config = readConfig();
      this.cart = null;
      this.pending = 0;
      this.queue = Promise.resolve();
      this.maxQty = MAX_QTY;
    }

    /* ---------- події ---------- */
    emit(name, detail) {
      document.dispatchEvent(new CustomEvent(name, { detail: detail }));
    }

    setLoading(active) {
      this.pending += active ? 1 : -1;
      if (this.pending < 0) this.pending = 0;
      if (active && this.pending === 1) this.emit('cart:loading', { active: true });
      if (!active && this.pending === 0) this.emit('cart:loading', { active: false });
    }

    /* ---------- транспорт ---------- */
    async request(url, options) {
      var res;
      try {
        res = await fetch(url, Object.assign({ headers: { Accept: 'application/json' }, credentials: 'same-origin' }, options));
      } catch (e) {
        throw new CartError('network', 0, null);
      }
      var data = null;
      try { data = await res.json(); } catch (e) { data = null; }
      if (!res.ok || (data && data.status && data.status >= 400)) {
        var status = (data && data.status) || res.status;
        throw new CartError((data && (data.description || data.message)) || 'http_' + status, status, data);
      }
      return data;
    }

    post(url, body) {
      return this.request(url, {
        method: 'POST',
        headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
        body: JSON.stringify(body),
      });
    }

    /* Мутації виконуються послідовно; loading = реальний час запиту. */
    run(reason, task, extra) {
      var self = this;
      var job = this.queue.then(async function () {
        self.setLoading(true);
        try {
          var result = await task();
          var cart = result.cart;
          self.cart = cart;
          var sections = result.sections || (await self.fetchSections());
          self.applyCart(cart);
          self.applySections(sections);
          self.emit('cart:change', Object.assign({ reason: reason, cart: cart, sections: sections }, extra || {}));
          return cart;
        } catch (e) {
          var err = e instanceof CartError ? e : new CartError('unknown', 0, null);
          self.emit('cart:error', { reason: reason, status: err.status, message: err.message, data: err.data });
          throw err;
        } finally {
          self.setLoading(false);
        }
      });
      this.queue = job.catch(function () {});
      return job;
    }

    sectionIds() {
      return Array.isArray(this.config.sections) ? this.config.sections : [];
    }

    sectionsPayload() {
      var ids = this.sectionIds();
      return ids.length ? { sections: ids.join(','), sections_url: window.location.pathname } : {};
    }

    async fetchSections() {
      var ids = this.sectionIds();
      if (!ids.length) return null;
      return this.request(window.location.pathname + '?sections=' + encodeURIComponent(ids.join(',')), { headers: {} });
    }

    /* ---------- читання ---------- */
    async get() {
      var cart = await this.request(route('cart_url', '/cart') + '.js');
      this.cart = cart;
      return cart;
    }

    qtyOf(variantId) {
      if (!this.cart) return 0;
      return this.cart.items.reduce(function (s, i) { return i.variant_id === Number(variantId) ? s + i.quantity : s; }, 0);
    }

    /* ---------- мутації ---------- */
    /** items: {id, quantity?, properties?} ; кількість рядка обмежена 99. */
    async add(item) {
      var self = this;
      if (!this.cart) { try { await this.get(); } catch (e) { /* помилку покаже сама мутація */ } }
      var room = this.maxQty - this.qtyOf(item.id);
      var qty = Math.min(Math.max(1, Number(item.quantity) || 1), Math.max(0, room));
      if (qty <= 0) {
        var capped = new CartError('max_qty', 422, null);
        this.emit('cart:error', { reason: 'add', status: 422, message: 'max_qty', data: null });
        throw capped;
      }
      return this.run('add', async function () {
        var body = Object.assign({ items: [Object.assign({}, item, { quantity: qty })] }, self.sectionsPayload());
        var data = await self.post(route('cart_add_url', '/cart/add') + '.js', body);
        var cart = await self.get();
        return { cart: cart, sections: data.sections || null };
      }, { id: item.id, quantity: qty });
    }

    /** key або line (1-based). qty <= 0 - видалення. */
    setQty(target, qty) {
      var self = this;
      var q = Math.min(this.maxQty, Math.floor(Number(qty) || 0));
      if (q <= 0) return this.remove(target);
      return this.change('qty', target, q);
    }

    remove(target) {
      return this.change('remove', target, 0);
    }

    change(reason, target, quantity) {
      var self = this;
      var body = Object.assign({ quantity: quantity }, typeof target === 'number' ? { line: target } : { id: String(target) }, this.sectionsPayload());
      return this.run(reason, async function () {
        var data = await self.post(route('cart_change_url', '/cart/change') + '.js', body);
        return { cart: data, sections: data.sections || null };
      }, { target: target, quantity: quantity });
    }

    clear() {
      var self = this;
      return this.run('clear', async function () {
        var cart = await self.post(route('cart_url', '/cart') + '/clear.js', {});
        return { cart: cart, sections: null };
      });
    }

    /* ---------- правила A-006/A-009/A-010 (значення з налаштувань теми) ---------- */
    /** total, minOrder, freeShipping - у одиницях валюти (не копійках). */
    totalOf(cart) { return ((cart || this.cart || {}).total_price || 0) / 100; }
    minOrder() { return Number(this.config.minOrder) || 0; }
    freeShippingFrom() { return Number(this.config.freeShipping) || 0; }
    meetsMin(cart) { return this.totalOf(cart) >= this.minOrder(); }
    minLeft(cart) { return Math.max(0, this.minOrder() - this.totalOf(cart)); }
    shipping(cart) {
      var t = this.totalOf(cart), th = this.freeShippingFrom();
      return { threshold: th, left: Math.max(0, th - t), pct: th ? Math.min(1, t / th) : 0, free: th > 0 && t >= th };
    }

    /* ---------- DOM ---------- */
    applyCart(cart) {
      var n = cart.item_count;
      document.querySelectorAll('[data-cart-count]').forEach(function (el) {
        el.textContent = String(n);
        el.hidden = n === 0;
      });
    }

    /* Елемент [data-lystia-render="<section id>"] замінюється відповідним з Section Rendering. */
    applySections(sections) {
      if (!sections) return;
      Object.keys(sections).forEach(function (id) {
        var html = sections[id];
        if (!html) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        document.querySelectorAll('[data-lystia-render="' + id + '"]').forEach(function (target) {
          var fresh = doc.querySelector('[data-lystia-render="' + id + '"]');
          if (fresh) target.innerHTML = fresh.innerHTML;
        });
      });
    }
  }

  /* A-103: повернення «Назад» з чекаута (checkout.lystia.store) віддає сторінку з bfcache разом зі застарілою шторкою,
     а Chekly міг прибрати позиції з кошика Shopify - тому оновлюємо сторінку, щоб шторка показала справжній кошик. */
  window.addEventListener('pageshow', function (e) { if (e.persisted) window.location.reload(); });

  window.LystiaCart = window.LystiaCart || new LystiaCartService();
  window.LystiaCartError = CartError;
})();
